import React from 'react'
import Loader from 'react-loader-spinner'
import './ArcButton.scss'

interface IProps {
  disabled?: boolean
  onClick: () => void
  name: string
  className?: string
  loading?: boolean
  type?: 'primary' | 'secondary'
}

export function ArcButton({
  disabled = false,
  loading = false,
  name,
  onClick,
  type = 'primary',
  className = '',
}: IProps) {
  return (
    <button
      className={`arc-button ${type} ${className}`}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? <Loader type="Grid" color="white" height={25} /> : name}
    </button>
  )
}
